module.exports = __webpack_public_path__ + "5aad6781bf1842d768e7d728adcf31a2.png";